import { B01HeroBannerProps } from './B01HeroBanner.type';
import { HeroBannerProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function GetHeroBannerModel(props?: B01HeroBannerProps): HeroBannerProps {
  const { params, fields } = props || {};

  const { renderRichText, renderText, renderLink } = useConditionalRendering();
  return {
    headline: renderText(fields?.Heading, { required: true }),
    backgroundGradientLevel: getDroplink(params?.BackgroundGradientLevel, '0'),
    backgroundImage: {
      src: fields?.BackgroundImage?.value?.src ?? '',
      alt: (fields?.BackgroundImage?.value?.alt ?? '') as string,
    },
    mobileBackgroundImage: fields?.MobileBackgroundImage?.value?.src,
    supportingCopy: renderRichText(fields?.SupportingCopy),
    firstCTALink: renderLink(fields?.FirstCTALink),
    secondCTALink: renderLink(fields?.SecondCTALink),
    shouldHideImgOnMobile: params?.HideImageOnMobile,
    shouldLeftAlignOnMobile: params?.LeftAlignOnMobile,
  };
}
